"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
//
// assets
//
const appsCopy_1 = require("copy/appsCopy");
const Toast_1 = __importDefault(require("components/general/Toast/Toast"));
const useToast_1 = __importDefault(require("components/general/Toast/useToast"));
//
// components
//
const AppModule_1 = __importDefault(require("./AppModule"));
//
// styles
//
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const StyledErrorText_1 = require("components/Dashboard/StyledErrorText");
const StyledMediumText_1 = require("components/Dashboard/StyledMediumText");
const graphql_1 = require("./graphql");
const AccountContext_1 = require("contexts/AccountContext");
const staticApps = [
    {
        id: 'rebuy',
        name: 'Rebuy',
        installed: false,
        installUrl: 'https://help.gomalomo.com/csc/how-to-set-up-a-rebuy-widget-for-your-malomo-track'
    },
    {
        id: 'gorgias',
        name: 'Gorgias',
        installed: false,
        installUrl: 'https://help.gomalomo.com/csc/integrating-malomo-gorgias'
    },
    {
        id: 'junip',
        name: 'Junip',
        installed: false,
        installUrl: 'https://help.gomalomo.com/csc/integrating-malomo-and-junip'
    },
    {
        id: 'justuno',
        name: 'Justuno',
        installed: false,
        installUrl: 'https://help.gomalomo.com/csc/integrating-malomo-and-justuno'
    },
    {
        id: 'yotpo',
        name: 'Yotpo',
        category: 'Email & SMS Marketing',
        installed: false,
        installUrl: 'https://help.gomalomo.com/csc/integrating-malomo-and-yotpo-sms-email'
    },
    {
        id: 'corso',
        name: 'Corso',
        installed: false,
        installUrl: 'https://help.gomalomo.com/csc/how-to-add-corso-to-your-malomo-tracking-page'
    }
];
function listApps(apps, uninstallCallback) {
    const appList = [...apps, ...staticApps];
    return appList.map((app) => {
        return react_1.default.createElement(AppModule_1.default, { app: app, key: app.id, onUninstall: uninstallCallback });
    });
}
const Apps = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const { toastParams, setToastMessage } = (0, useToast_1.default)();
    const { data: appListings, error, loading: appListingsLoading, refetch: refetchAppListtings } = (0, client_1.useQuery)(graphql_1.GET_APP_LISTINGS, {
        variables: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            accountId: account.id
        },
        skip: !account
    });
    const [uninstallAppMutation] = (0, client_1.useMutation)(graphql_1.UNINSTALL_APP, {
        onCompleted: () => __awaiter(void 0, void 0, void 0, function* () {
            yield refetchAppListtings();
            setToastMessage('Uninstalled');
        })
    });
    const uninstallApp = (0, react_1.useCallback)((clientId) => {
        if (!account) {
            return;
        }
        // we have to read `clientId` from the getAppListings call
        // but send it back as `appClientId`
        uninstallAppMutation({
            variables: {
                input: {
                    accountId: account.id,
                    appClientId: clientId
                }
            }
        });
    }, [account]);
    const appList = (0, react_1.useMemo)(() => {
        if (!(appListings === null || appListings === void 0 ? void 0 : appListings.appListings)) {
            return null;
        }
        return listApps(appListings === null || appListings === void 0 ? void 0 : appListings.appListings, uninstallApp);
    }, [appListings === null || appListings === void 0 ? void 0 : appListings.appListings]);
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, appsCopy_1.appsCopy.loading)));
    }
    function displayError() {
        if (!error) {
            return null;
        }
        if (error.message.includes('ECONNREFUSED') ||
            error.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, appsCopy_1.appsCopy.fetchError));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, error.message));
    }
    function renderApps() {
        if (!appListings) {
            return null;
        }
        return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'apps' },
            react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, appsCopy_1.appsCopy.mainHeader),
            appList));
    }
    if (error) {
        return displayError();
    }
    if (appListingsLoading) {
        return renderLoading();
    }
    return renderApps();
};
exports.default = Apps;
